import { Course } from '../core/types';
import { createElement } from '../utils/dom-helpers';
import { createLogger, LogLevel } from '../utils/logger';
import { getYmGoal } from '../../../../pages/catalog/assets/js/utils/helpYmGoals';

const logger = createLogger('TariffComparison', LogLevel.INFO);

const TARIFF_STYLES = ['green', 'purple', 'orange'];

export function createTariffComparison(course: Course): HTMLElement {
  logger.info('Создание блока сравнения тарифов', course);
  const wrapper = createElement('div', 'tariff__compare');
  wrapper.style.display = 'none';

  if (!course.benefits || !Array.isArray(course.benefits) || !course.tariffs) {
    logger.warn('Нет данных для сравнения тарифов', course);
    return wrapper;
  }

  // Фильтрация тарифов по is_active (0, false, пустой — пропускать)
  const filteredTariffs = (course.tariffs || []).filter(tariff => tariff.is_active !== 0 && tariff.is_active !== false && tariff.is_active !== '' && tariff.is_active !== undefined && tariff.is_active !== null);

  // Шапка сравнения
  const header = createElement('div', 'compare__header');
  const title = createElement('p', 'compare__header__title');
  title.textContent = 'Что входит в тариф';
  header.appendChild(title);

  const block = createElement('div', 'compare__block');
  filteredTariffs.forEach((tariff, index) => {
    const item = createElement('div', 'compare__block__item');
    const p = createElement('p', '');
    p.textContent = tariff.title;
    item.appendChild(p);
    block.appendChild(item);
  });
  header.appendChild(block);
  wrapper.appendChild(header);

  // Контент сравнения
  const content = createElement('ul', 'compare__content');
  course.benefits.forEach(benefit => {
    const row = createElement('li', 'compare__content__row');
    const ymGoal = getYmGoal('option');
    if (ymGoal) row.setAttribute('data-ym-goal', ymGoal);
    row.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
    const main = createElement('div', 'compare__main');

    // Открывашка
    const opener = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    opener.setAttribute('class', 'compare__opener');
    opener.setAttribute('width', '24');
    opener.setAttribute('height', '24');
    opener.setAttribute('viewBox', '0 0 24 24');
    opener.setAttribute('fill', 'none');
    opener.innerHTML = `
      <circle cx="12" cy="12" r="12" fill="white"/>
      <g clip-path="url(#clip0_2604_4736)"><path d="M13.5 10.5H18V13.5H13.5V18H10.5V13.5H6V10.5H10.5V6H13.5V10.5Z" fill="#808080"/></g>
      <defs><clipPath id="clip0_2604_4736"><rect width="12" height="12" fill="white" transform="translate(6 6)"/></clipPath></defs>
    `;
    main.appendChild(opener);

    // Название бенефита
    const benefitTitle = createElement('p', 'compare__title');
    benefitTitle.textContent = benefit.title;
    main.appendChild(benefitTitle);

    // Блок по тарифам
    const block = createElement('div', 'compare__block');
    filteredTariffs.forEach((tariff, index) => {
      let hasBenefit = false;
      let benefitValue: any = null;
      if (Array.isArray(tariff.benefits_tariff)) {
        for (const b of tariff.benefits_tariff) {
          if (String(b.id) === String(benefit.id)) {
            hasBenefit = true;
            benefitValue = b.value;
            break;
          }
        }
      }
      const colorClass = TARIFF_STYLES[index % TARIFF_STYLES.length];
      const item = createElement('div', `compare__block__item ${colorClass} ${hasBenefit ? '' : 'false'}`.trim());
      if (!benefit.is_numeric) {
        if (hasBenefit) {
          item.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21.8418 5.93945L13.5654 19.7334L10.4355 20.1191L2.15918 11.8418L4.9873 9.01367L11.4521 15.4785L18.4121 3.88086L21.8418 5.93945Z" fill="white" /></svg>`;
        } else {
          item.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.002 5.82812L14.8291 12.001L21.001 18.1729L19.5869 19.5869L18.1729 21.002L12.001 14.8291L5.8291 21.002L4.41504 19.5869L3.00098 18.1729L9.17188 12.001L3 5.82812L5.82812 3L12.001 9.17285L18.1738 3L21.002 5.82812Z" fill="#808080" /></svg>`;
        }
      } else if (benefitValue !== null && benefitValue !== undefined) {
        const span = createElement('span', '');
        span.textContent = String(benefitValue);
        item.appendChild(span);
      } else {
        item.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.002 5.82812L14.8291 12.001L21.001 18.1729L19.5869 19.5869L18.1729 21.002L12.001 14.8291L5.8291 21.002L4.41504 19.5869L3.00098 18.1729L9.17188 12.001L3 5.82812L5.82812 3L12.001 9.17285L18.1738 3L21.002 5.82812Z" fill="#808080" /></svg>`;
      }
      block.appendChild(item);
    });
    main.appendChild(block);
    row.appendChild(main);

    // Описание бенефита
    if (benefit.description) {
      const desc = createElement('p', 'compare__description');
      desc.textContent = benefit.description;
      row.appendChild(desc);
    }
    content.appendChild(row);
  });
  wrapper.appendChild(content);

  logger.info('Блок сравнения тарифов создан', wrapper);
  return wrapper;
} 